import React from "react";
import LoadingGif from '../img/loading.gif'
import './styles/result.scss';

const Loading = (props) => {
    return(
        <div id="resultSection" className="resultSection" style={{backgroundColor: 'white', borderRadius: '14px', minHeight: '100vh',color: 'white', width: '90%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: 'auto', transform: 'scale(0.95)'}}> 
            <img src={LoadingGif} style={{width: '64px', height: '64px'}} alt="loading"/>
        </div>
    )
}

export default Loading;